<template>
  <div class="content">
    <base-header class="pb-6">
    </base-header>
    <b-container fluid class="mt--6">
      <card class="bg-transparent" >
        <template slot="header">
          <div style="display: flex;">
            <div>
              <h3 class="mb-0">Failed synchronizations</h3>
              <p class="text-sm mb-0">
                Overview of failed synchronizations across organisations (only active syncs are shown)
              </p>
            </div>
          </div>
        </template>
        <div>
          <b-row>
            <b-col cols="12">
              <b-card no-body v-if="loadSyncResults">
                <b-card-header>
                  <h5 class="h3 mb-0">Results</h5>
                  <div style="flex: 1.5;">
                    <base-button size="sm" type="neutral" @click.native="handleRefresh()" style="float: right;">Refresh</base-button>
                  </div>
                </b-card-header>
                <b-card-body>
                  <sync-result-card v-for="(item, index) in failedSyncResults" :syncResult="item" :showOrganisation="true"></sync-result-card>
                  <div v-if="failedSyncResults && failedSyncResults.length === 0">
                    No results found.
                  </div>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </card>
    </b-container>
  </div>
</template>

<script>
import crudApi from "../../crud/crud-api";
import SyncResultCard from "../Management/SyncResultCard";

export default {
  name: "FailedSyncs",
  components: {
    SyncResultCard,
  },
  data: _ => ({
    syncResults: null,
    failedSyncResults: null,
  }),
  methods: {
    getSyncResults() {
      crudApi.getLastSyncResults().then(json => this.syncResults = json.data ? json.data : json)
    },
    handleRefresh() {
      this.getSyncResults()
    },
    getFailedSyncResults() {
      let failedSyncs = []

      for (let r of this.syncResults) {
        if (!r.success && !this.isMoreThanDayOld(r.timestamp)) {
          failedSyncs.push(r)
        }
      }

      return failedSyncs
    },
    isMoreThanDayOld(isoString) {
      const t = new Date(isoString).getTime();
      if (Number.isNaN(t)) return false;
      return (Date.now() - t) > 24 * 60 * 60 * 1000;
    }
  },
  computed: {
    loadSyncResults() {
      this.getSyncResults()

      return true
    },
  },
  watch: {
    syncResults: function (newValue) {
      this.failedSyncResults = this.getFailedSyncResults()
    }
  }
}
</script>

<style scoped>

</style>
